/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Connection_GoneInputs */



/**
* | output |
* | --- |
* | "This connection no longer exists. Reload the page." |
*
* @param {Private_Models_Save_Connection_GoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_connection_gone = /** @type {((inputs?: Private_Models_Save_Connection_GoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Connection_GoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Verbindung gibt es nicht mehr. Laden Sie die Seite neu.")
	return /** @type {LocalizedString} */ ("This connection no longer exists. Reload the page.")
});